<app-documents
  [borrower]="borrower"
  [documents]="viewableDocuments$ | async"
  [documentCategories]="documentCategories$ | async"
  [canProcessDocs]="canProcessDocs$ | async"
  [canSoftPullCredit]="canSoftPullCredit$ | async"
  [canUseDRSDocumentVerify]="canUseDRSDocumentVerify$ | async"
  [creditPullDisableMessage]="creditPullDisableMessage"
  [sending]="sending$ | async"
  [documentAlert]="documentAlert$ | async"
  [ocrolusAlert]="ocrolusAlert$ | async"
  [creditAlert]="creditAlert"
  [isUploading]="isUploading$ | async"
  [isPullingCredit]="isPullingCredit"
  [uploadedPercent]="uploadedPercent"
  [showUploadedBy]="showUploadedBy"
  [uploadProgress]="uploadProgress"
  [isFundingDesk]="isFundingDesk$ | async"
  [tableColumns]="tableColumns"
  [showActions]="showActions"
  [defaultPageSize]="defaultPageSize"
  [showPageSizeOptions]="showPageSizeOptions"
  [viewableMimetypes]="viewableMimetypes$ | async"
  (ocrolusAlertDismissed)="dismissOcrolusAlert()"
  (documentAlertDismissed)="dismissDocumentAlert()"
  (creditAlertDismissed)="dismissCreditAlert()"
  (updateDoc)="handleUpdateDocument($event)"
  (updateDocDrsVerification)="handleUpdateDocumentDrsVerification($event)"
  (processDocs)="handleProcessDocuments($event)"
  (uploadDoc)="handleUploadDocument($event)"
  (repullCred)="handleRepullCredit($event)"
  (triggerExperianCommercial)="handleExperianCommercialCreditPull($event)">
</app-documents>
